import React, {useState, useEffect} from 'react'
// import ProfileSidebar from './ProfileSidebar'
import {FormationDatas} from '../../datas/FormationDatas'
import { Link, useLocation } from 'react-router-dom'
import '../FindJob/FindJob.css'
import FormationCard from '../../components/Cards/FormationCard'
import InputIcon from '../../../components/Form/InputIcon'
import Select from '../../../components/Form/Select'
import location from "../../assets/searchIcon/location.svg"
import category from "../../assets/searchIcon/category.svg"
import FormationCardSkeleton from "../../components/Skeletons/FormationCardSkeleton"
import back11 from '../../assets/Illustrations/RemoteCommunication.jpeg'
import LayoutSwitcher from '../../components/LayoutSwitcher'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTrainings } from '../../../redux/TrainingSlice'
import image1 from "../../assets/images/back_formation.jpg"
import { fetchCategoriesByType } from '../../../redux/categorySlice'
import SelectIcon from '../../../components/Form/SelectIcon'
import RowPagination from "../../components/Pagination"
import ResultNotFound from "../../components/ResultNotFound"
import { motion } from 'framer-motion'

const Formation = () => {
  const dispatch = useDispatch();
  const { trainings, loading, error } = useSelector(state => state.training);
  const { items: categories, status } = useSelector((state) => state.categories);
  const [filters, setFilters] = useState({
    keyword: '',
    location: '',
    category: '',
    page: 1,
    limit: 10
  });
  const [listStyle, setListStyle] = useState('md:grid-cols-1');
  
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => { 
    dispatch(fetchCategoriesByType("training"));
}, [dispatch]);

  // Appel API pour récupérer toutes les formations avec filtres
  const fetchFilteredTrainings = () => {
    dispatch(fetchTrainings(filters)); // Déclencher l'action Redux avec les filtres
  };

  useEffect(() => {
    dispatch(fetchTrainings({   
      location: filters.location,
      category: filters.category,
      keyword: filters.keyword,
      page: filters.page,
      limit: 10,
    })); 
  }, [filters.page]); 

  // Gérer les changements des filtres (mot-clé, localisation, etc.)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({
      ...prev,
      page: newPage+1,
    }));
  };

  // Gérer la recherche
  // const handleSearch = () => {
  //   fetchFilteredTrainings(); // Déclencher une nouvelle recherche avec les filtres actuels
  // };

  return (
    <div className=''>
      <div className="bg-purple-300 h-56 w-full px-6 lg:px-20 xl:px-40 py-8 no-repeat object-cover bg-cover bg-center" style={{ backgroundImage: `url(${image1})` }}>
        <div className="flex justify-between mb-10">
          <h5 className='font-semibold text-lg'>Formation</h5>
          <li className="flex gap-x-2 text-sm items-center">
            <ul className="text-gray-600"> <Link to="/home">Accueil</Link> / </ul>
            <ul className="font-medium">Formation</ul>
          </li>
        </div>

        <div className="bg-white rounded-lg shadow h-16 p-2">
          <div className="grid lg:grid-cols-7 sm:grid-cols-5 grid-cols-3">
            <InputIcon
              className='col-span-2'
              name="keyword"
              placeholder='Mot clé ...'
              noBorder={true}
              value={filters.keyword}
              onChange={handleInputChange}
            />
            <InputIcon
              className='col-span-2 hidden sm:block'
              name="location"
              icon={location}
              placeholder='Localisation'
              noBorder={true}
              value={filters.location}
              onChange={handleInputChange}
            />
              <SelectIcon
            options={categories.map((cat) => ({
              value: cat.id,
              label: cat.name,
            }))}
            value={filters.category}
            className="col-span-2 hidden lg:block"
            icon={category}
            name="category"
            placeholder="Sélectionner un secteur"
            noBorder={true}
            onChange={handleInputChange}
          />
            {/* <InputIcon
              className='col-span-2 hidden lg:block'
              name={category}
              placeholder='Sélectionner un secteur'
              noBorder={true}
              value={filters.category}
              onChange={handleInputChange}
            /> */}
            <div className="grid gap-x-2">
              <button onClick={()=>dispatch(fetchTrainings({   
                location: filters.location,
                category: filters.category,
                keyword: filters.keyword,
                page: 1,
                limit: 10,
              }))} 
              className="p-4 py-3 bg-black rounded-md text-white font-medium">
                Rechercher
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* customise list display */}
      <div className="bg-white px-6 lg:px-20 xl:px-40 h-16 shadow-sm -6 py-3">
        <div className="flex justify-between items-center">
          <div className="flex gap-2 items-center"> 
          <span className="text-lg font-semibold"> {trainings?.total} Résultats </span>
          </div>

          <div className="flex gap-2 items-center"> 
          <span>Par page </span>
          <Select name="limit" className="w-40" options={["10", "15","30"]} mb='0' onChange={(e)=>setFilters({...filters, limit: e.target.value})}/> 
          
          <LayoutSwitcher setListStyle={setListStyle} listStyle={listStyle} />
          </div>
          
         
        </div>
      </div>

      <div className="flex-1 px-6 lg:px-20 xl:px-40 bg-primary-beige pb-14 pt-6">
        <div className="py-3">
          <div className={`grid grid-cols-1 min-[1920px]:grid-cols-3 md:grid-cols-1 sm:grid-col-span-1 gap-6 ${listStyle}`}>
            {loading ? (
              Array.from({ length: 6 }).map((_, index) => (
              <FormationCardSkeleton key={index}/>
              ))
            ) : (
              (trainings?.total > 0) ?
              (trainings?.data?.map((item, index) => (
                <motion.div
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -100 }}
                transition={{ duration: 0.5 + index/10 }}
                // key={job?._id}
                >
             <FormationCard key={item.id} item={item} />
              </motion.div>
                
              )))
              :
              <ResultNotFound/>
            )}
            {/* {error && <div className="text-red-500">Erreur: {error}</div>} */}
          </div>
        </div>

        <RowPagination
    currentPage={filters?.page || 1}
    setCurrentPage={handlePageChange}
    totalPages={trainings?.last_page }
    />
      </div>
    </div>
  );
};

export default Formation;